var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, keyframes = styledComponents.keyframes;
var shimmer = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%{\n    background-position: -500px 0\n  }\n  100%{\n    background-position: 500px 0\n  }\n"], ["\n  0%{\n    background-position: -500px 0\n  }\n  100%{\n    background-position: 500px 0\n  }\n"])));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 4px;\n  animation-duration: 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: ", ";\n  animation-timing-function: linear;\n  background: #f6f7f8;\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n  background-size: 1000px 104px;\n  margin-bottom: 8px;\n"], ["\n  border-radius: 4px;\n  animation-duration: 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: ", ";\n  animation-timing-function: linear;\n  background: #f6f7f8;\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n  background-size: 1000px 104px;\n  margin-bottom: 8px;\n"])), shimmer);
var Shimmer = (function (_super) {
    __extends(Shimmer, _super);
    function Shimmer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Shimmer.prototype.render = function () {
        var rest = __rest(this.props, []);
        return React.createElement(Wrapper, __assign({}, rest));
    };
    return Shimmer;
}(React.PureComponent));
export default Shimmer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=shimmer.js.map